const basePricing = {
  fullDayPrice: 36, // Base price for a full day of daycare
  halfDayMultiplier: 0.8, // Half-day is 80% of full-day price
  additionalDogDiscount: 5, // Discount for additional dog
  packageDiscounts: [
    { numDays: 4, fullDay: 0.94, halfDay: 0.96 }, // Discounts for 4 days
    { numDays: 8, fullDay: 0.89, halfDay: 0.93 }, // Discounts for 8 days
    { numDays: 12, fullDay: 0.8, halfDay: 0.86 }, // Discounts for 12 days
  ],
  subscriptionDiscount: 0.71, // Subscription is 71% of base price
  subscriptionGroomingCredit: 20, // Grooming credit
  subscriptionBoardingPrice: 35, // Discounted boarding price
};

const baseBoardingPricing = {
  overnightPrice: 50, // Base price for overnight boarding (first dog)
  additionalDogDiscount: 5, // Discount for additional dog
  packageDiscounts: [
    { numDays: 12, perNightPrice: 40 }, // Discounted price per night for 12-night package
    { numDays: 20, perNightPrice: 37 }, // Discounted price per night for 20-night package
  ],
};


const servicesAndPricing = {

  address: '4844 Voltaire Street San Diego, CA 92107',
  email: 'thedoglodgesd@gmail.com',

  phone1: '(619) 304-2323',
  phone2: '(619) 304-2323',

// DAYCARE PRICING

daycare: {
  daycarePricing: {
    header: "DAYCARE PRICING",
    items: [
      // {
      //   title: "Half Day",
      //   get cost() {
      //     const halfDayPrice = (basePricing.fullDayPrice * basePricing.halfDayMultiplier).toFixed(0);
      //     const additionalDogPrice = (halfDayPrice - basePricing.additionalDogDiscount).toFixed(0);
      //     return `$${halfDayPrice} / $${additionalDogPrice} additional dog`;
      //   },
      //   details: "Daycare up to 5 hours",
      // },
      {
        title: "Full Day",
        get cost() {
          const additionalDogPrice = (basePricing.fullDayPrice - basePricing.additionalDogDiscount).toFixed(0);
          return `$${basePricing.fullDayPrice.toFixed(0)} / $${additionalDogPrice} additional dog`;
        },
        details: "Daycare up to 12 hours",
      },
    ],
  },

  daycarePackages: {
    // header: "DAYCARE PACKAGES",
    // items: basePricing.packageDiscounts.flatMap((pkg) => [
    //   {
    //     title: `${pkg.numDays} Half Days`,
    //     numDays: pkg.numDays,
    //     get costPerDay() {
    //       return (basePricing.fullDayPrice * basePricing.halfDayMultiplier * pkg.halfDay).toFixed(0);
    //     },
    //     get cost() {
    //       return `$${(pkg.numDays * this.costPerDay).toFixed(0)}`;
    //     },
    //     get details() {
    //       return `Enjoy flexibility and savings at just $${this.costPerDay} per day!`;
    //     },
    //   },
    //   {
    //     title: `${pkg.numDays} Full Days`,
    //     numDays: pkg.numDays,
    //     get costPerDay() {
    //       return (basePricing.fullDayPrice * pkg.fullDay).toFixed(0);
    //     },
    //     get cost() {
    //       return `$${(pkg.numDays * this.costPerDay).toFixed(0)}`;
    //     },
    //     get details() {
    //       return `Plan ahead and save with a rate of $${this.costPerDay} per day.`;
    //     },
    //   },
    // ]),
  },

  monthlySubscriptions: {
    // header: "MONTHLY RECURRING SUBSCRIPTIONS",
    // items: [
    //   {
    //     title: "Unlimited Daycare",
    //     numDays: 30,
    //     get cost() {
    //       return `$${(basePricing.fullDayPrice * basePricing.subscriptionDiscount * this.numDays).toFixed(2)} / Month`;
    //     },
    //     get details() {
    //       const originalCost = basePricing.fullDayPrice * this.numDays;
    //       const subscriptionCost = originalCost * basePricing.subscriptionDiscount;
    //       const savings = (originalCost - subscriptionCost).toFixed(2);
    //       return `Save $${savings} compared to daily rates! Includes $${basePricing.subscriptionGroomingCredit} grooming credit per month + discounted boarding ($${basePricing.subscriptionBoardingPrice}/night).`;
    //     },
    //   },
    // ],
  },
},

//  daycare: {

//    daycarePricing:{
//     header: "DAYCARE PRICING",
   
//    items:[
//      {
//        title: "Half Day",
//        cost: "$28 / $25 additional dog",
//        details: "Daycare up to 5 hours",
//      },
//      {
//        title: "Full Day",
//        cost: "$35 / $30 additional dog",
//        details: "Daycare up to 12 hours",
//      },
//    ],
//   },
  
//   daycarePackages: {
//     header: "DAYCARE PACKAGES",
//     items: [
//       {
//         title: "4 Half Days",
//         numDays: 4,
//         costPerDay: 27,
//         get cost() {
//           return `$${this.numDays * this.costPerDay}`;
//         },
//         get details() {
//           return `Enjoy flexibility and savings at just $${this.costPerDay} per day!`;
//         },
//       },
//       {
//         title: "4 Full Days",
//         numDays: 4,
//         costPerDay: 33,
//         get cost() {
//           return `$${this.numDays * this.costPerDay}`;
//         },
//         get details() {
//           return `Plan ahead and save with a rate of $${this.costPerDay} per day.`;
//         },
//       },
//       {
//         title: "8 Half Days",
//         numDays: 8,
//         costPerDay: 25,
//         get cost() {
//           return `$${this.numDays * this.costPerDay}`;
//         },
//         get details() {
//           return `Ideal for frequent visitors—just $${this.costPerDay} per day.`;
//         },
//       },
//       {
//         title: "8 Full Days",
//         numDays: 8,
//         costPerDay: 31,
//         get cost() {
//           return `$${this.numDays * this.costPerDay}`;
//         },
//         get details() {
//           return `Your pup’s adventures, simplified at $${this.costPerDay} per day.`;
//         },
//       },
//       {
//         title: "12 Half Days",
//         numDays: 12,
//         costPerDay: 24,
//         get cost() {
//           return `$${this.numDays * this.costPerDay}`;
//         },
//         get details() {
//           return `Maximize value with a rate of $${this.costPerDay} per day.`;
//         },
//       },
//       {
//         title: "12 Full Days",
//         numDays: 12,
//         costPerDay: 28,
//         get cost() {
//           return `$${this.numDays * this.costPerDay}`;
//         },
//         get details() {
//           return `Best for regulars—$${this.costPerDay} per day for stress-free planning.`;
//         },
//       },
//     ],
//   },
  

//   monthlySubscriptions: {
//     header: "MONTHLY RECURRING SUBSCRIPTIONS",
//     items: [
//       {
//         title: "Unlimited Daycare",
//         numDays: 30,
//         costPerDay: 35,
//         subscriptionCost: 750, // Fixed monthly subscription cost
//         get cost() {
//           return `$${this.subscriptionCost} / Month`;
//         },
//         get details() {
//           const originalCost = this.numDays * this.costPerDay;
//           const discount = originalCost - this.subscriptionCost;
//           return `Save $${discount} compared to daily rates! Includes $20 grooming credit per month + discounted boarding ($35/night).`;
//         },
//       },
//     ],
//   },
  
  

//  },







// BOARDING PRICING
boardingPricing : {
  overnightBoarding: {
    header: "OVERNIGHT BOARDING",
    items: [
      {
        title: "Per 26 hr",
        get cost() {
          return `$${baseBoardingPricing.overnightPrice.toFixed(0)} per dog`;
        },
        details: "",
      },
    ],
  },

  boardingPackages: {
    // header: "BOARDING PACKAGES (365 DAY EXPIRATION)",
    // items: baseBoardingPricing.packageDiscounts.map((pkg) => ({
    //   title: `${pkg.numDays} Nights`,
    //   numDays: pkg.numDays,
    //   get costPerDay() {
    //     return pkg.perNightPrice.toFixed(0);
    //   },
    //   get cost() {
    //     return `$${(pkg.numDays * pkg.perNightPrice).toFixed(0)}`;
    //   },
    //   get details() {
    //     return `Only $${this.costPerDay} /night!`;
    //   },
    // })),
  },
},

//  boardingPricing: {
//   overnightBoarding : {
//     header: "OVERNIGHT BOARDING",
//     items: [
//       {
//         title: "Per 26 hr",
//         cost: "$40 / $35 Additional dog",
//         details: "",
//       },
//     ],
//   },
  
//   boardingPackages: {
//     header: "BOARDING PACKAGES (365 DAY EXPIRATION)",
//     items: [
//       {
//         title: "12 Nights",
//         numDays: 12,
//         costPerDay: 35,
//         get cost() {
//           return `$${this.numDays * this.costPerDay}`;
//         },
//         get details() {
//           return `Only $${this.costPerDay} /night!`;
//         },
//       },
//       {
//         title: "20 Nights",
//         numDays: 20,
//         costPerDay: 33,
//         get cost() {
//           return `$${this.numDays * this.costPerDay}`;
//         },
//         get details() {
//           return `Only $${this.costPerDay} /night!`;
//         },
//       },
//     ],
//   },

//  },







// GROOMING PRICING
  groomingPricing: {
    header: "GROOMING PRICING",
    items: [
    {
      title: "Nail Trim",
      cost: "$22",
      details: "Performed with a Dremel grinder to create smooth nails as short as possible without causing discomfort or pain.",
    },
    {
      title: "Teeth Brushing",
      cost: "$18",
      details: "Includes soft plaque removal with disposable brushes and dental spray. Does not remove hardened tartar or stains.",
    },
    {
      title: "Ear Cleaning",
      cost: "$26 - $83",
      details: "Uses an all-natural herbal ear wash to cleanse and soothe ears. Does not address infections.",
    },
    {
      title: "Brush Out / Dematting",
      cost: "$31 - $79",
      details: "Specialized grooming brushes are used for your dog’s coat type. Excessive matting may incur additional charges.",
    },
    {
      title: "Basic Bath",
      cost: "$25 - $100",
      details: "Includes shampoo wash, rinse, and a 10-minute blow-dry using all-natural products. Pricing varies by size.",
    },
    {
      title: "Full Bath",
      cost: "$36 - $132",
      details: "Includes shampoo, conditioning, blow-dry, brushing, nail trim, ear cleaning, and teeth brushing. Pricing varies by size.",
    }
  ]
},




// // TRAINING PRICING
//   trainingSessionsPricing : {
//     header: "TRAINING PRICING",
//     items: [
//       {
//         title: "Leash Manners 101",
//         cost: "$69",
//         details: "Learn loose leash walking and tactical heel",
//       },
//       {
//         title: "Leash Manners 201",
//         cost: "$69",
//         details: "Improve heel, handle distractions, and build confidence",
//       },
//       {
//         title: "Recall & Engagement",
//         cost: "$69",
//         details: "Develop reliable recall and enhance attention",
//       },
//       {
//         title: "Basic Obedience",
//         cost: "$69",
//         details: "Master sit, stay, down, leave it, and more",
//       },
//       {
//         title: "Trick Training",
//         cost: "$69",
//         details: "Learn spin, play dead, high-five, and more",
//       },
//       {
//         title: "Brain Games & Sensory Enrichment",
//         cost: "$69",
//         details: "Practice nosework, urban parkour, and body awareness",
//       },
//       {
//         title: "Structured Play & Drive Development",
//         cost: "$69",
//         details: "Engage in flirt pole, tug-of-war, and fetch",
//       },
//       {
//         title: "Trainer's Choice",
//         cost: "$69",
//         details: "Custom session designed by a certified trainer to meet your dog’s unique needs and goals",
//       },
//     ],
//   },





// BUS PRICING
  busPricing : {
    header: "PICK-UP AND DROP-OFF PRICING",
    items: [
      {
        title: "One-Way Service",
        cost: "$21",
        details: "Available within a 5-mile radius. Single charge covers all dogs in the household.",
      },
      {
        title: "Round-Trip Service",
        cost: "$35",
        details: "Pick-up and drop-off together, save $7!",
      },

      {
        title: "Other Times",
        cost: "Varies",
        details: "Requires at least one day's advance notice. Subject to driver availability.",
      },

      {
        title: "Long Distance Service",
        cost: "$21 + $1.50 /additional mile ",
        details: "For locations beyond the 5-mile radius. Requires at least one day's advance notice. Subject to driver availability.",
      },
    ],
  },




// PACK HIKE PRICING
  packHikePricing: {
    header: "PACK HIKE PRICING",
    items: [
      {
        title: "Pack Hike",
        cost: "$28",
        details: "An on-leash outdoor adventure to San Diego’s scenic trails. Includes supervision by experienced dog hikers and group play with other furry friends. Available weekdays only.",
      },
    ],
  },



// PUPPY PRICING
puppyPricing: {
  header: "PUPPY PRICING",
  items: [
    {
      title: "Puppies (Under 1 Year)",
      cost: "+$25",
      details: "Additional charge applies to all daycare and boarding services for puppies under 1 year old.",
    },
    {
      title: "Young Dogs (Under 3 Years)",
      cost: "+$15",
      details: "Additional charge applies to all daycare and boarding services for dogs under 3 years old.",
    },
  ],
},

// TREAT PRICING
 treatPricing: {
  header: "TREAT TIMES PRICING",
  items: [
    // {
    //   title: "Bowl Boosts",
    //   cost: "$4",
    //   details: "Joint, Digestive, and Calming options. Functional all-natural supplements.",
    // },
    {
      title: "Lick Puzzles",
      cost: "$5",
      details: "Food-based enrichment activity, easy level. Great for relaxation and mental stimulation.",
    },
    {
      title: "Stuffed Kongs",
      cost: "$5",
      details: "Food-based enrichment activity, medium level. Perfect for food-motivated or enrichment puzzle pros.",
    },
  ],
},





}


export default servicesAndPricing